import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { actions } from '../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';

const FilterBookmarkedPractices = () => {
    const dispatch = useDispatch();
    // bool to filter for bookmarked practices
    const bookmarked = useSelector(state => state.practice.bookmarked);

    const buttonTitle = bookmarked ? `Show all practices` : `Filter bookmarked practices`;

    const getButtonClasses = (isActive) => isActive ? 'text-light bg-primary' : 'text-primary bg-light';

    const buttonClasses = `rounded-circle ${getButtonClasses(bookmarked)}`;

    const buttonHandler = () => dispatch(actions.practice.setBookmarked(!bookmarked));

    const icon = useMemo(() => <FontAwesomeIcon icon={faBookmark} />, []);

    return (
        <Button title={buttonTitle} className={buttonClasses} onClick={buttonHandler}>
            {icon}
        </Button>
    );
};

export default React.memo(FilterBookmarkedPractices);
